import { Container, ContentLayout, Header, Tabs, TabsProps } from "@amzn/awsui-components-console";
import React from "react";
import { useLocation } from "react-router-dom";

import ConfigDrivenClaimsHistory from "src/claimsHistory/ConfigDrivenClaimsHistory";
import { routeLineOfBusiness, SEARCH_CONFIG_REGISTRY } from "src/claimsHistory/registry";

const SEARCH_TAB_LABEL = "Search for Claims";

/**
 * The claims history page shell: the heading, the container, and the tabs. The
 * content of every tab is the configuration-driven page, which resolves its own
 * configuration from the line of business the route carries.
 *
 * The shell renders before any configuration has been retrieved, so the tab set
 * is declared in the registry rather than read from the resolved document —
 * otherwise the my-submitted-claims tab could not appear until a fetch resolved,
 * and would vanish on a fetch that failed.
 */
const ClaimsHistory = () => {
  const { pathname } = useLocation();

  // The route is the one source of the line of business. Reading it here as the
  // configuration resolver reads it leaves a single derivation, rather than this
  // view trusting a value another page derived from the same pathname earlier.
  const lob = routeLineOfBusiness(pathname);

  const mySubmittedClaimsTabLabel =
    lob === null ? undefined : SEARCH_CONFIG_REGISTRY[lob]?.mySubmittedClaimsTabLabel;

  const tabs: TabsProps.Tab[] = [
    {
      label: SEARCH_TAB_LABEL,
      id: "searchResults",
      content: <ConfigDrivenClaimsHistory mySubmittedClaims={false} />,
    },
  ];

  if (mySubmittedClaimsTabLabel !== undefined) {
    tabs.push({
      label: mySubmittedClaimsTabLabel,
      id: "mySubmittedClaims",
      content: <ConfigDrivenClaimsHistory mySubmittedClaims={true} />,
    });
  }

  return (
    <ContentLayout disableOverlap={false} header={<Header variant="h1">Claims History</Header>}>
      <Container fitHeight>
        <Tabs fitHeight data-testid="claims-history-tabs" tabs={tabs} />
      </Container>
    </ContentLayout>
  );
};

export default ClaimsHistory;
